import { Container, Img } from '@react-email/components';
import { merge } from 'lodash';

const image = {
    EditorElement: props => {
        const { attributes, children, element } = props;
        const imageSrc = element.attributes.src;
        const placeHolderAttributes = imageSrc
            ? {}
            : { style: { height: '200px' } };

        const containerStyle = {
            style: {
                maxWidth: '100%',
            },
        };

        return (
            <Container
                contentEditable={false}
                {...attributes}
                {...merge(
                    {},
                    placeHolderAttributes,
                    element.containerAttributes,
                    containerStyle,
                )}
            >
                {children}
                {imageSrc && (
                    <Img
                        {...merge(
                            {},
                            element.attributes,
                            placeHolderAttributes,
                        )}
                    />
                )}
            </Container>
        );
    },
    PreviewElement: ({ node, attributes }) => {
        const containerStyle = {
            style: {
                maxWidth: '100%',
            },
        };
        return (
            <Container {...merge({}, node.containerAttributes, containerStyle)}>
                {node?.data?.href ? (
                    <a href={node.data.href} target="_blank">
                        <Img {...attributes} />
                    </a>
                ) : (
                    <Img {...attributes} />
                )}
            </Container>
        );
    },
};

export default image;
